var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu"},[_c('div',{staticClass:"menu_items"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/menu"}},[_vm._v("Works")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/bddi"}},[_vm._v("Les BDDI")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9b2c6c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MobileMenu.vue
// module id = null
// module chunks = 